export default [
    {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
        resource: 'home',
        action: 'read'
    },
    {
        title: 'Point of sale',
        icon: 'ShoppingCartIcon',
        route: 'cash-selector',
        resource: 'tpv',
        action: 'read',
    },
    {
        title: 'Calendar',
        route: 'calendar',
        icon: 'CalendarIcon',
        resource: 'home',
        action: 'read',
    }
 ]
